/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function clearNaviBarRightItem(options, context) {
    var api = 'dd.biz.navigation.setRight';
    var formatInput = function () { return ({
        control: false,
        text: '分享',
    }); };
    context.DDCall(api, options, { formatInput: formatInput });
}

export { clearNaviBarRightItem as default };
